import type { ReactNode } from 'react'
import styles from './OCRScopingJobMainPanel.module.css'

export interface OCRScopingJobMainPanelProps {
  children?: ReactNode
}

export function OCRScopingJobMainPanel({
  children,
}: OCRScopingJobMainPanelProps) {
  return <div className={styles.root}>{children}</div>
}
